module.exports = __webpack_public_path__ + "c3728300a89693f6c480249cb412d5f1.jpg";